export default {
  confirm: 'Bevestigen',
  title: 'Beschikbare aanbiedingen',
};
